import Bankstatements from "./common/pages/Bankstatements";
import '../src/style.scss';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Verifyopt from "./common/pages/Verifyopt";
import Navbar from "./common/pages/Navbar";
import JointLogo from "./common/pages/JointLogo";
import SelectBank from "./common/pages/SelectBank";
import Footer from "./common/pages/Footer";
import LinkAccount from "./common/pages/LinkAccount";
import ConfirmConsent from "./common/pages/ConfirmConsent";
import FinalResult from "./common/pages/FinalResult";
import { SubmitConsent } from "./common/Apiservices";
import { useEffect ,useState,useRef} from "react";
import { HeaderforLoginOtpSocket } from "./common/helper/HeaderMakerforSocket";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { toast} from 'react-toastify';
import { ProviderForMyApp } from "./AppContext";
import { useMyContext } from "./AppContext";
import Badpage from "./common/pages/Badpage";
import SuccessPage from "./common/pages/SuccessPage";
function App() {
  const [userData,SetUserData]=useState();
  const [Socketconnnection,SetSocketconnection]=useState();
  const {Storage,SetStorage}=useMyContext();
  const [Error,SetError]=useState(false);
  const urlString = window.location.href;
  const url = new URL(urlString);
  const token = url.searchParams.get('token');
  const platform=url.searchParams.get('platform');
  const user_type=url.searchParams.get('user_type')
  
if(token!=null)
{ 
  localStorage.setItem('access_token',token);
  if(platform!=null)
  {
    localStorage.setItem('platform',platform);
  }
  
  if(user_type!=null)
  {
    localStorage.setItem('user_type',user_type);
  }
  else if(localStorage.getItem('user_type')===null) {
    localStorage.setItem('user_type',"null");
  }

  // console.log(localStorage.getItem('platform'),localStorage.getItem('user_type'))

}
const insession=localStorage.getItem('insession');


// useEffect(() => {
//  SubmitConsentBeforeSocketConnection();
// }, [])


// const HandleSocketConnection=(userData)=>{

//   let socket=localStorage.getItem('socket');
// // console.log(socket);
//   // if(!socket)
//       socket = new WebSocket(process.env.REACT_APP_WEB_SOCKET_URL); 

      
//      socket.onopen = () => {
  
//         console.log('WebSocket connection established.');
//         // HandleMakeConnection(socket,userData);
//       };
      
//       socket.onmessage = (event) => {
//         const receivedMessage = JSON.parse(event.data);
//         console.log("DATA  ",receivedMessage)
//       };
//       Storage.Socketconnnection=socket;
//       Storage.userid = userData.username;
//       Storage.consentHandle = userData.consentHandle;
//       Storage.mobilenumber = userData.mobileNum;
//       Storage.userData=userData;
//       Storage.sessionid=localStorage.getItem('sessionid');
//       SetStorage(Storage);
  
//    localStorage.setItem("socket",socket);
//       socket.onclose = () => {

//         console.log('WebSocket connection closed.');
//         toast.error("Session Closed");
//         localStorage.removeItem('socket');
//         localStorage.removeItem('sessionid');

//         setTimeout(()=>{
//               localStorage.clear();
      // window.opener = null;
      //  window.open('', '_self');
      //  window.close();
//         },1500)
   

//       };
//   }
  // const SubmitConsentBeforeSocketConnection=()=>{
 
  //   SubmitConsent().then((response)=>{
  //     if(response.status==200)
  //     {
  //     //  SetPendingRequest(false);
  //       HandleSocketConnection(response.data);
  //     }
  //     else{
        
  //     }
  //   }).catch((error)=>{
      
   
  //     window.opener = null;
  //        window.open('', '_self');
  //        window.close();
  //   })
  // }
  
return(
     <>
   {/* <ProviderForMyApp> */}
   <div className="app">
   <Router>
    <Routes>
      {/* <Route path="/" element={<><Navbar title="Bank Statement"/><Bankstatements userData={userData} Error={Error}/></>} /> */}
      <Route path="/" element={<><Navbar title="Verify OTP"/><JointLogo/><Verifyopt  userData={userData} Error={Error}/></>} />
      <Route path="/selectbank"  element={<><Navbar title="Select Bank"/><JointLogo/><SelectBank/></>}/>
    
      <Route path="/link_account"element={<><Navbar title="Link Account"/><JointLogo/><LinkAccount/></>} />
      <Route path="/confirmconsent"element={<> <Navbar title="Confirm Consent"/><JointLogo/><ConfirmConsent/></>} />
      <Route path="/finalresult"element={<><FinalResult/></>} />
      <Route path="/under-review" element={<SuccessPage/>} />
      <Route path="*" element={<Badpage/>}/>
    </Routes>
   </Router>
   {/* <Footer /> */}
   <ToastContainer  className="toastifyclass" />
   </div>
   {/* </ProviderForMyApp> */}
   </>
  );
}

export default App;
